const viewportBreakpoint = {
  tablet: 768, //px
  desktop: 1280, //px
}

export { viewportBreakpoint }